import OBase from './OBase';

export default class StreamFilter extends OBase {
  update () {
    let gInputTree = this.getFloatInput('Gate');
    let looping = true;
    let count = 0;
    let dataTrees = [];

    while (looping) {
      let inputName = 'Stream ' + count;
      if (!(inputName in this.inputs) || this.inputs[inputName].paramObject === null) {
        looping = false;
      } else {
        let dataTree = this.getObjectInput(inputName);
        dataTrees.push(dataTree);
        count++;
      }
    }

    let sOutput = this.outputs['Stream'].paramObject;
    let gValue = gInputTree.branches[0][0];
    let outTree = dataTrees[gValue % dataTrees.length];

    // console.log(outTree)
    sOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/StreamFilter.js